import {
    DATA_DICTIONARY_BASKET_ADD,
    DATA_DICTIONARY_BASKET_ADD_MANY,
    DATA_DICTIONARY_BASKET_REMOVE,
    DATA_DICTIONARY_BASKET_CLEAR,
    DATA_DICTIONARY_BASKET_STORAGE_KEY
} from './types';

// The basket stores a trimmed projection of the field DTO: enough for display
// (badges, tooltips), the Query Builder (keys, FK targets, decodes) and the
// export kit (descriptions, sensitivity) — not the full usage payload.
const toBasketItem = (f) => ({
    columnKey: f.columnKey,
    schema: f.schema,
    table: f.table,
    column: f.column,
    sqlType: f.sqlType || f.clrType || null,
    isNullable: !!f.isNullable,
    isPrimaryKey: !!f.isPrimaryKey,
    lookupDecode: f.lookupDecode || null,
    foreignKeyTargetTable: f.foreignKeyTargetTable || null,
    foreignKeyTargetColumn: f.foreignKeyTargetColumn || null,
    sensitivityClassification: f.sensitivityClassification || null,
    description: f.description || null,
    verificationStatus: f.verificationStatus || null,
    uiLabel: f.uiLabel || null
});

const persist = (getState) => {
    try {
        window.localStorage.setItem(
            DATA_DICTIONARY_BASKET_STORAGE_KEY,
            JSON.stringify(getState().dataDictionaryBasket.items)
        );
    } catch (e) {
        // Storage unavailable/full — the basket still works for this session.
    }
};

export const addFieldToBasket = (field) => (dispatch, getState) => {
    dispatch({ type: DATA_DICTIONARY_BASKET_ADD, payload: toBasketItem(field) });
    persist(getState);
};

export const addFieldsToBasket = (fields) => (dispatch, getState) => {
    dispatch({ type: DATA_DICTIONARY_BASKET_ADD_MANY, payload: (fields || []).map(toBasketItem) });
    persist(getState);
};

export const removeFieldFromBasket = (columnKey) => (dispatch, getState) => {
    dispatch({ type: DATA_DICTIONARY_BASKET_REMOVE, payload: columnKey });
    persist(getState);
};

export const clearBasket = () => (dispatch, getState) => {
    dispatch({ type: DATA_DICTIONARY_BASKET_CLEAR });
    persist(getState);
};
